import { render, staticRenderFns } from "./IncomingDetail.vue?vue&type=template&id=587e5ace&scoped=true&"
import script from "./IncomingDetail.vue?vue&type=script&lang=js&"
export * from "./IncomingDetail.vue?vue&type=script&lang=js&"
import style0 from "./IncomingDetail.vue?vue&type=style&index=0&id=587e5ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e5ace",
  null
  
)

export default component.exports